module.exports = __webpack_public_path__ + "img/service_img3.86990ec5.png";